import { OpenApiOperationParameter } from './OpenApiOperationParameter';
import { openApiSchema } from './openApiSchema';

export function getOpenApiOperationParameters(path: string, method: string) {
    const parameters = [
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...((openApiSchema as any).paths[path]?.[method]?.parameters ?? []),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...((openApiSchema as any).paths[path]?.parameters ?? []),
    ];
    return parameters as OpenApiOperationParameter[];
}
